import * as React from 'react';

import classnames from 'classnames';

import {LoadingText} from 'shells/loading-placeholder/loading-text';

import {AccentBorder} from '../../accent-border/accent-border';
import {RemoveButton} from '../../button/remove-button/remove-button';
import {Card} from '../../card/card';
import {colors} from '../../colors/colors';

type Props = {
    name: string;
    onRemove?: () => void;
    isLoading?: boolean;
    borderColor?: string;
    onClick?: () => void;
    isDisabled?: boolean;
};

export function SelectedFieldCard(props: Props) {
    const classNames = classnames({
        disabled: props.isDisabled,
        'pad-8': true,
        flex: true,
        'justify-sb': true,
        'align-center': true,
        'font-size-normal': true,
    });

    return (
        <div className='pb-8'>
            <Card hasBorder={true} onClick={props.onClick}>
                <AccentBorder location='left' color={props.borderColor || colors.lead}>
                    <div className={classNames}>
                        {props.isLoading ? (
                            <LoadingText height={27} />
                        ) : (
                            <>
                                {props.name}
                                {props.onRemove ? (
                                    <RemoveButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            // @ts-expect-error
                                            props.onRemove();
                                        }}
                                        size={12}
                                    />
                                ) : null}
                            </>
                        )}
                    </div>
                </AccentBorder>
            </Card>
        </div>
    );
}
